import { navigation } from './navigation'
import { storeLocator, initMap } from './store-locator'
import { blogFilter } from './blog-filter'
import { comparisonChart } from './comparison-chart'
import { accordionBlock } from './accordionBlock'
import { reviews } from './reviews'
import { initVideos } from './videos'
import { blogSection } from './blog-section'
import { logoMarquee } from './logo-marquee'
import { anchors } from './anchors'
import { featuredPost } from './featuredPost'
import { pageHero } from './pageHero'

navigation()
storeLocator()
blogFilter()
comparisonChart()
accordionBlock()
reviews()
initVideos()
blogSection()
logoMarquee()
anchors()
featuredPost()
pageHero()

window.initMap = initMap
